<!-- 导读书目详情 -->
<template>
    <!-- 书目详情 -->
    <div class="guide-book-container">
        <div class="guide-head-container">
            <div class="guide-left-head-container" @click = backPage>
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="guide-right-head-container">书目详情</div>
            <div class="like-guide-left-head-container">
                <div v-if="bookForm.isCollect===0" @click="addOrCancelCollectBook" title="收藏" class="book-like-container">
                    <svg t="1772522514725" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7438" data-spm-anchor-id="a313x.search_index.0.i26.36a13a818WfYrR" width="32" height="32"><path d="M527.7 144.2l110.4 223.7c2.4 4.9 7.1 8.3 12.6 9.1l246.8 35.9c13.7 2 19.2 18.8 9.3 28.5L728.2 615.5c-3.9 3.8-5.7 9.4-4.8 14.8l42.2 245.8c2.3 13.6-12 24-24.2 17.6L520.5 777.6c-4.9-2.6-10.7-2.6-15.5 0L284.2 893.7c-12.3 6.4-26.6-4-24.2-17.6l42.2-245.8c0.9-5.4-0.9-10.9-4.8-14.8L118.7 441.4c-9.9-9.7-4.4-26.5 9.3-28.5L374.8 377c5.4-0.8 10.1-4.2 12.6-9.1l110.4-223.7c6.1-12.4 23.8-12.4 29.9 0z" fill="#cdcdcd" p-id="7439" data-spm-anchor-id="a313x.search_index.0.i22.36a13a818WfYrR" class="selected"></path></svg>
                </div>
                <div v-if="bookForm.isCollect===1" @click="addOrCancelCollectBook" title="收藏" class="book-like-container">
                    <svg t="1772522514725" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7438" width="32" height="32"><path d="M527.7 144.2l110.4 223.7c2.4 4.9 7.1 8.3 12.6 9.1l246.8 35.9c13.7 2 19.2 18.8 9.3 28.5L728.2 615.5c-3.9 3.8-5.7 9.4-4.8 14.8l42.2 245.8c2.3 13.6-12 24-24.2 17.6L520.5 777.6c-4.9-2.6-10.7-2.6-15.5 0L284.2 893.7c-12.3 6.4-26.6-4-24.2-17.6l42.2-245.8c0.9-5.4-0.9-10.9-4.8-14.8L118.7 441.4c-9.9-9.7-4.4-26.5 9.3-28.5L374.8 377c5.4-0.8 10.1-4.2 12.6-9.1l110.4-223.7c6.1-12.4 23.8-12.4 29.9 0z" fill="#0d54a4" p-id="7439" data-spm-anchor-id="a313x.search_index.0.i22.36a13a818WfYrR" class="selected"></path></svg>
                </div>
                <div v-if="bookForm.isLike===0" @click="bookIsLike" title="点赞" class="book-like-container">
                    <svg t="1772522999642" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8558" style="margin-top: 2px;" width="28" height="28"><path d="M64 483.04V872c0 37.216 30.144 67.36 67.36 67.36H192V416.32l-60.64-0.64A67.36 67.36 0 0 0 64 483.04zM857.28 344.992l-267.808 1.696c12.576-44.256 18.944-83.584 18.944-118.208 0-78.56-68.832-155.488-137.568-145.504-60.608 8.8-67.264 61.184-67.264 126.816v59.264c0 76.064-63.84 140.864-137.856 148L256 416.96v522.4h527.552a102.72 102.72 0 0 0 100.928-83.584l73.728-388.96a102.72 102.72 0 0 0-100.928-121.824z" p-id="8559" fill="#b7b7b7"></path></svg>
                </div>
                <div v-if="bookForm.isLike===1" @click="bookIsLike"  title="点赞" class="book-like-container">
                    <svg t="1772522999642" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8558" style="margin-top: 2px;" width="28" height="28"><path d="M64 483.04V872c0 37.216 30.144 67.36 67.36 67.36H192V416.32l-60.64-0.64A67.36 67.36 0 0 0 64 483.04zM857.28 344.992l-267.808 1.696c12.576-44.256 18.944-83.584 18.944-118.208 0-78.56-68.832-155.488-137.568-145.504-60.608 8.8-67.264 61.184-67.264 126.816v59.264c0 76.064-63.84 140.864-137.856 148L256 416.96v522.4h527.552a102.72 102.72 0 0 0 100.928-83.584l73.728-388.96a102.72 102.72 0 0 0-100.928-121.824z" p-id="8559" fill="#0d54a4"></path></svg>
                </div>
            </div>
        </div>
        <el-scrollbar class="form-list-container">
            <div class="book-base-info-container">
                <div class="book-part1-l">
                    <div class="book-info-item-auto" v-show="bookForm.bookVideo">
                        <span class="item-span">导读视频：</span>
                    </div>
                    <!-- 导读视频  -->
                    <div class="book-video-container" v-show="bookForm.bookVideo">
                        <video id="videoElement"
                               :poster="bookForm.bookVideo + '?x-oss-process=video/snapshot,t_1,m_fast'" preload="none"
                               controls="controls" style="width: 75%;height: 100%;"
                               controlsList="nodownload"
                               :src="bookForm.bookVideo"></video>
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">书籍名称：</span>{{bookForm.bookName}}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">所属主题：</span>{{bookForm.bookItemName}}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">学段年级：</span>{{bookForm.periodName}}•{{bookForm.bookGradeName}}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">作者：</span>{{bookForm.bookAuthor}}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">出版时间：</span>{{ timestampDate(bookForm.publishTime) }}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">书籍简介：</span>
                    </div>
                    <div class="book-info-item-auto-80" title="书籍简介" style="text-indent: 30px">
                        {{bookForm.bookIntroduction}}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">推荐理由：</span>
                    </div>
                    <div class="book-info-item-auto-80" title="推荐理由" style="text-indent: 30px">
                        {{bookForm.bookReason}}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">书籍附件：</span>
                    </div>
                    <div class="b-file-info-container">
                        <div class="b-file-list">
                            <div class="b-file-item" v-for="item in fileList" :key="item">
                                <div class="b-file-title">{{item.fileName}}</div>
                                <div class="b-file-view" title="预览" v-if="!judgeIsPPT(item.fileType)">
                                    <el-image @click="handleFIleStatus(item.status)" class="b-file-icon" style="margin-top: 5px"
                                              :src="require('@/assets/file/file_view.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                    </el-image>
                                </div>
                                <div class="b-file-view" title="播放" v-if="judgeIsPPT(item.fileType)">
                                    <el-image @click="viewPPTFile(item.fileUrl)" class="ppt-file-icon" style="margin-top: 5px"
                                              :src="require('@/assets/file/ppt_play.png')">
                                    </el-image>
                                </div>
                                <div class="b-file-download" title="下载">
                                    <img class="b-file-icon" @click="downloadFile(item)" style="margin-top: 3px" src="../../../assets/file/file_download.png" alt="">
                                </div>
                            </div>
                            <div v-if="fileList.length===0" class="data-empty">
                                <div class="empty-icon"><img src="../../../assets/icon/img/data_empty.png" /></div>
                                <div class="empty-title">暂无附件</div>
                            </div>
                        </div>



                    </div>
                </div>
                <div class="book-part1-r">
                    <div class="book-info-item-auto">
                        <span class="item-span">书目封面：</span>
                    </div>
                    <div class="book-base-info-cover">
                        <img class="img-100"  :src="bookForm.bookCover" alt="">
                    </div>
                    <!-- 评论区-->
                    <div class="comment-container">
                        <div class="comment-title-box">
                            评论区
                        </div>
                        <div class="comment-input-container">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请输入内容"
                              v-model="discussWordContent"
                              autofocus></el-input>
                        </div>
                        <div class="comment-btn-box">
                            <div class="comment-limit">
                                <el-upload class="discuss-uploader"
                                           :action="serviceUrl+'/businessservice/book/uploadFile'"
                                           :show-file-list="false"
                                           :on-success="handleUploadImageSuccess"
                                           :headers="{ token }"
                                           accept=".png,.jpeg,.jpg"
                                           :before-upload="beforeImageUpload">
                                    <img class="icon-upload-img" alt="上传图片" src="../../../assets/icon/img/upload_img1.png">
                                </el-upload>
                            </div>
                            <div class="sub-comment-limit" @click="submitDiscuss">
                                发表
                            </div>

                        </div>
                        <!--  评论内容 -->
                        <div class="comment-show-container">
                            <div class="b-discuss-one" v-for="item in discussList">
                                <div class="b-discuss-user-avatar">
                                    <img class="b-discuss-user-avatar-img" alt="无" @error="onImageError" :src="item.avatar">
                                </div>
                                <div class="b-discuss-user-content">
                                    <div class="b-user-info">
                                        <div class="b-flex-item b-user-true-name">{{item.createUserName}}</div>
                                        <div class="b-flex-item b-content-time">{{timestampToTime(item.createTime)}}</div>
                                    </div>
                                    <div class="b-content-info" v-if="item.discussType===1">
                                        {{item.content}}
                                    </div>
                                    <div class="b-img-info" v-if="item.discussType===2">
                                        <el-image alt="" :src="item.imgContent"
                                                  :preview-src-list="item.imgList" ></el-image>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="discussList.length===0" class="data-empty">
                            <div class="empty-icon"><img src="../../../assets/icon/img/data_empty.png" /></div>
                            <div class="empty-title">暂无数据</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>
<script>
import {timestampDate, timestampToTime} from "@/utils/date";
import {infoBook,submitBookDiscuss,listBookDiscuss,addOrCancelBook,likeClickBook} from "@/api/admin/book";
import {serviceUrl} from "@/utils/global";
import {ElLoading} from "element-plus";
import {downloadFile} from "@/api/adminservice/public";

export default {
    name:'readBookInfo',
    components:{},
    props:{
        markInfo:{
            type: String,
            default:null
        },
        itemId:{
            type: String,
            default:null
        },
    },
    watch:{
        markInfo(newValue,oldValue){
            this.showMode = 'pageSub';
        },
        itemId(newValue,oldValue){
            this.bookId = newValue;
            this.queryBookInfo();
            this.queryDisList();
        },
    },
    mounted() {
    },
    data() {
        return {
            serviceUrl,
            token: this.$storage.get("token"),
            bookId:'',
            bookForm:{},  //数据
            timestampToTime,
            timestampDate,
            //评论区
            discussType:1, //研讨内容类型：1-文字 2-图片
            discussWordContent:'',
            wordContent: '',//文字评论
            imgContent: '',//图片评论
            discussList:[],
            fileList:[],
        }
    },
    methods: {
        focusInput(){
            this.closeInput = false
        },
        queryBookInfo(){
            infoBook({ bookId: this.bookId }).then(res => {
                if (res.data.code === 1) {
                    this.bookForm = res.data.data;
                    this.fileList = this.bookForm.fileList;
                }else {
                    this.$message.error("操作失败")
                }
            });
        },
        backPage(){
            this.$emit('back-book-page', 'readMuseum');
        },
        // 评论区
        handleUploadImageSuccess(response, uploadFile){
            if (uploadFile.response.code === 1) {
                this.imgContent = uploadFile.response.data;
                this.discussType = 2
                this.submitDiscuss()
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeImageUpload(rawFile){
            if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        submitDiscuss(){

            const obj = {
                bookId: this.bookId,
                content: this.wordContent,
                imgContent: this.imgContent,
            };
            //文字评论
            if (this.discussType===1){
                this.wordContent = this.discussWordContent
                if (this.wordContent===''){
                    this.$message.info("讨论内容不能为空")
                    return
                }
                obj.content=this.wordContent;
                obj.imgContent = '';
                obj.fileContent = ''
            }
            //图片评论
            if (this.discussType===2){
                if (this.imgContent===''){
                    this.$message.info("研讨内容不能为空")
                    return
                }
                obj.content='';
                obj.imgContent = this.imgContent;
                obj.fileContent = ''
            }
            const loading = ElLoading.service({ fullscreen: true })
            submitBookDiscuss(obj).then(res =>{
                if (res.data.code === 1) {
                    this.$message.success("发表成功");
                    this.wordContent = ''
                    this.discussWordContent = ''
                    this.imgContent = ''
                    this.discussType = 1
                    this.queryDisList();
                    loading.close();
                } else {
                    this.$message.error(res.data.msg)
                    this.discussType = 1
                    loading.close();
                }
            })

        },
        queryDisList(){
            this.discussList = [];
            listBookDiscuss({ bookId: this.bookId }).then(res => {
                if (res.data.code === 1) {
                    this.discussList = res.data.data;
                }else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        viewFile(file){},
        viewPPTFile(fileUrl){
            const openUrl = 'https://ow365.cn/?i=36735&ssl=1&furl=' +fileUrl;
            window.open(openUrl, '_blank')
        },
        judgeIsPPT(fileType){
            if (!fileType){
                return false;
            }
            return fileType.toLowerCase().includes("ppt");
            // return false;
        },
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status){
            if (status === 1) {
            }else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,){
            const list = [];
            for (let i = 1; i <=page ; i++) {
                list.push(baseUrl+'/' + i+'.png?'+new Date());
            }
            return list;
        },
        addOrCancelCollectBook(){
            addOrCancelBook({ collectType: 5, relationId: this.bookForm.bookId }).then(res => {
                if (res.data.code === 1) {
                    if (this.bookForm.isCollect === 1) {
                        this.bookForm.isCollect = 0;
                        this.bookForm.collectCount = this.bookForm.collectCount - 1;
                        this.$message.success("收藏取消");
                    } else {
                        this.bookForm.isCollect = 1;
                        this.bookForm.collectCount = this.bookForm.collectCount + 1;
                        this.$message.success("收藏成功");
                    }
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        bookIsLike() {
            likeClickBook({ relationId: this.bookForm.bookId }).then(res => {
                if (res.data.code === 1) {
                    if (this.bookForm.isLike === 1) {
                        this.bookForm.isLike = 0;
                        this.bookForm.likeCount = this.bookForm.likeCount - 1;
                        this.$message.success("点赞取消");
                    } else {
                        this.bookForm.isLike = 1;
                        this.bookForm.likeCount = this.bookForm.likeCount + 1;
                        this.$message.success("点赞成功");
                    }
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
    }
}
</script>
<style scoped>
.guide-book-container{
    width: 100%;
    height: calc(100vh - 174px);
    background: #ffffff;
    border-radius: 16px;
    padding: 20px 28px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
.guide-head-container{
    flex-shrink: 0;
    width: 100%;
    height: 44px;
    display: flex;
}
.guide-left-head-container{
    width: 80px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
    display: flex;
}
.guide-right-head-container{
    width: calc(100% - 160px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    line-height: 44px;
    font-weight: bold;
}

.like-guide-left-head-container{
    width: 80px;
    height: 44px;
    padding-left: 10px;
    display: flex;
}
.book-like-container{
    width: 30px;
    height: 30px;
    margin-top: 5px;
    margin-right: 10px;
    cursor: pointer;
}


.form-list-container{
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 0;
    box-sizing: border-box;
}
.book-base-info-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    display: flex;
}
.book-part1-l{
    width: calc(100% - 220px);
    height: 100%;
    padding-right: 20px;
    box-sizing: border-box;
}
.book-info-item-auto{
    width: 100%;
    height: auto;
    line-height: 25px;
    display: flex;
    font-size: 15px;
    margin-top: 5px;
}
.book-info-item-auto-80{
    width: 95%;
    height: auto;
    line-height: 25px;
    display: flex;
    font-size: 15px;
    margin-top: 5px;
}
.book-part1-r{
    width: 220px;
    height: 100%;
}
.book-base-info-cover{
    width: 210px;
    height: 297px;
    box-sizing: border-box;
    img{
        width: 100%;
        height: 100%;
    }
}
.item-span{
    font-weight: bold;
    color: #ff7f2e;
}
.book-video-container{
    width: 100%;
    height: auto;
}
.comment-container{
    width: 100%;
    height: 200px;
    padding: 20px 10px 0 0;
    box-sizing: border-box;
}
.comment-title-box{
    height: 20px;
    line-height: 20px;
    background-color: rgba(255,255,255,.9);
    color: #ffbf6b;
    font-weight: bold;
    border-left: 4px solid #ff7f2e;
    font-size: 16px;
    margin-bottom: 10px;
    text-indent: 2px;
}
.comment-input-container{
    display: inline-block;
    width: 210px;
    ::v-deep .el-textarea__inner::placeholder{
        font-size: 12px;
    }
    ::v-deep .el-textarea__inner{
        font-size: 12px;
    }
}

.comment-btn-box{
    display: flex;
    //padding: 0 6px;
    box-sizing: border-box;
    margin-top: 10px;
}
.comment-limit{
    width: 26px;
    height: 26px;
    background-color: #ff7f2e;
    font-size: 12px;
    color: #999aaa;
    border-radius: 13px;
    margin-right: 10px;
    .icon-upload-img{
        width: 20px;
        height: 20px;
        margin: 3px 0 0 3px;
    }
}

.sub-comment-limit{
    width: 56px;
    height: 24px;
    margin-left: 120px;
    background-color: #ff7f2e;
    color: #fff;
    border-radius: 12px;
    text-align: center;
    font-size: 12px;
    cursor: pointer;
    line-height: 24px;
}

.comment-show-container{
    width: 100%;
    height: auto;
    padding-top: 10px;
}
.b-discuss-one{
    display: flex;
    padding-bottom: 10px;
    background-color: rgba(255,255,255,.8);
    box-sizing: border-box;

}
.b-discuss-user-avatar{
    width: 40px;
}

.b-discuss-user-avatar-img{
    width: 30px!important;
    height: 30px;
    border-radius: 15px!important;
}
.b-discuss-user-content{
    width: 160px;
    font-size: 14px;
}
.b-user-info{
    display: flex;
    height: 25px;
    padding-right: 10px;
    box-sizing: border-box;
}
.b-user-true-name{
    font-size: 12px;
    height: 25px;
    line-height: 25px;
    text-align: left;
    margin-right: 10px;
    align-content: flex-start;
}
.b-content-time{
    line-height: 25px;
    font-size: 12px;
    align-content: flex-end;
}
.b-content-info{
    padding: 2px 10px 0 0;
    font-size: 11px;
    color: #525B68;
    line-height: 16px;
    word-wrap:break-word;
    word-break:break-all;

}
.b-img-info{
    padding: 2px 10px 0 0;
    display: flex;
    width: 160px;
    flex-wrap: wrap;
    .el-image{
        width: 120px;
        height: auto;
        margin: 0 5px 5px 0;
    }
}

.b-file-info-container{
    width: 100%;
    height: auto;
}
.b-file-list{
    width: calc(100% - 60px);
    height: auto;
}
.b-file-item{
    display: flex;
    height: 30px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 2px solid #a7a7a7;
}
.b-file-item:hover{
    color: #ff7f2e!important;
    font-weight: bold;
    border-bottom: 2px solid #ff7f2e!important;
}
.b-file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
    line-height: 30px;
    cursor: pointer;
}
.b-file-view{
    width: 30px;
    height: 100%;
}
.b-file-download{
    width: 30px;
    height: 100%;
}
.b-file-icon{
    width: 20px;
    height: 20px;
    cursor: pointer;
}
.ppt-file-icon{
    width: 20px;
    height: 18px;
    cursor: pointer;
}
</style>